/*
 *   File : delete modal.js
 *   Author : https://evoqins.com
 *   Description : delete modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Delete Modal Component ---------- */
export default function DeleteModal({
  open = false,
  message,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onCancel} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0"
        style={{
          zIndex: 1055,
          width: "600px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{ backdropFilter: "blur(2px)" }}
          className="d-flex flex-column justify-content-between bg-white bg-opacity-80 align-items-center border-bottom p-24"
        >
          <div className="d-flex w-100 justify-content-between">
            <h4 className="mb-0 fs-16 fw-500 text-eerie-black">Delete</h4>

            <PrimaryButton
              icon="close"
              ClassName="bg-transparent p-0"
              onPress={onCancel}
            />
          </div>

          {/* Message */}
          <div className="d-flex w-100 py-36">
            <h5 className="fw-400 fs-14 text-start lh-24 text-eerie-black mb-0">
              {message || "Are you sure you want to delete this item?"}
            </h5>
          </div>

          {/* Footer Buttons */}
          <div className="d-flex justify-content-end w-100 mt-3 column-gap-3">
            <PrimaryButton
              name="Cancel"
              ClassName="rounded-pill bg-transparent border-oxford-blue lh-24 py-3 text-oxford-blue w-100 fs-16 fw-500"
              onPress={onCancel}
            />
            <PrimaryButton
              name="Confirm"
              ClassName="rounded-pill bg-oxford-blue lh-24 py-3 text-white w-100 fs-16 fw-500"
              onPress={onConfirm}
            />
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
